import React from "react";
import Alert from "@mui/joy/Alert";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import CircularProgress from "@mui/joy/CircularProgress";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import Warning from "@mui/icons-material/Warning";

function ErrorDialogMessage({ errorMessage, onClickFunction }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Stack spacing={2} sx={{ maxWidth: 400 }}>
        <Alert
          variant="soft"
          color="danger"
          invertedColors
          startDecorator={
            <CircularProgress size="lg">
              <Warning />
            </CircularProgress>
          }
          sx={{ alignItems: "flex-start", "--Alert-gap": "1rem" }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ mt: 1 }}>{errorMessage}</Typography>
            <Box
              sx={{
                mt: 2,
                display: "flex",
                justifyContent: "flex-end",
                gap: 1,
              }}
            >
              <Button variant="soft" size="sm" onClick={onClickFunction}>
                Retry
              </Button>
            </Box>
          </Box>
        </Alert>
      </Stack>
    </div>
  );
}

export default ErrorDialogMessage;
